import {
  Component,
  OnInit,
  AfterViewInit,
  ViewChild,
  TemplateRef,
  setTestabilityGetter,
  ChangeDetectorRef,
  HostBinding
} from '@angular/core';
import { Store, Select } from '@ngxs/store';
import { ActivatedRoute, Router } from '@angular/router';
import { TournamentState } from '../../stores/tournament/tournament.state';
import { Observable, BehaviorSubject } from 'rxjs';
import {
  SetRegionFilter,
  SetFormatFilter
} from '../../stores/tournament/tournament.actions';
import { Tournament } from '../../stores/tournament/models/Tournament';
import {
  trigger,
  state,
  style,
  transition,
  animate
} from '@angular/animations';

const TABS = [
  { label: 'overview', value: 'overview', isActive: false },
  { label: 'tournaments', value: 'tournaments', isActive: false },
  { label: 'events', value: 'events', isActive: false },
  { label: 'members', value: 'members', isActive: false },
  { label: 'teams', value: 'teams', isActive: false }
];

@Component({
  selector: 'leagueplay-tournaments',
  templateUrl: './tournaments.component.html',
  styleUrls: ['./tournaments.component.scss']
})
export class TournamentsComponent implements OnInit, AfterViewInit {
  constructor(
    public store: Store,
    public route: ActivatedRoute,
    public router: Router
  ) {}

  @Select(TournamentState.filters) filters$: Observable<any>;

  @Select(TournamentState.tournaments) tournaments$: Observable<Tournament>;

  public bgStyle = {};

  @ViewChild('overview', { static: false }) overview: TemplateRef<any>;
  @ViewChild('tournaments', { static: false }) tournaments: TemplateRef<any>;
  @ViewChild('events', { static: false }) events: TemplateRef<any>;
  @ViewChild('members', { static: false }) members: TemplateRef<any>;
  @ViewChild('teams', { static: false }) teams: TemplateRef<any>;

  showLatestResults = true;

  public tabTemplate$: BehaviorSubject<TemplateRef<any>> = new BehaviorSubject(
    undefined
  );

  public tabs$: BehaviorSubject<any[]> = new BehaviorSubject(TABS);

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.bgStyle = {
        background: `linear-gradient(
          180deg,
          rgba(20, 21, 25, 0.5) 0%,
          rgba(20, 21, 25, 0.83) 50%,
          rgba(20, 21, 25, 1) 95%
        ), url('/assets/images/games/${params['communitySlug']}/banner.png')`
      };
    });
  }

  ngAfterViewInit() {
    this.route.queryParams.subscribe(params => {
      // Because of change detection
      setTimeout(() => this.selectTab(params.tab), 0);
    });
  }

  toggleLatestResults() {
    this.showLatestResults = !this.showLatestResults;
  }

  regionSelected(region) {
    this.store.dispatch(new SetRegionFilter(region));
  }

  formatSelected(format) {
    this.store.dispatch(new SetFormatFilter(format));
  }

  selectTab(tab: string) {
    if (!this[tab]) tab = 'overview';

    const tabs = [...TABS];

    tabs.forEach(t => {
      if (t.value === tab) {
        t.isActive = true;
      } else t.isActive = false;
    });

    this.tabs$.next(tabs);
    this.tabTemplate$.next(this[tab]);
    this.router.navigate([], {
      relativeTo: this.route,
      queryParams: { tab }
    });
  }
}
